import styled from "styled-components";

export const HeaderContent = styled.header`
  background-color: var(--color-grey-0);

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 136.8rem;
    margin: 0 auto;
    padding: 1rem;
  }
`;
